var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuspicious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 11H34.2c-6.37 0-9.556 0-11.99 1.24a11.375 11.375 0 00-4.97 4.97C16 19.645 16 22.83 16 29.2v41.6c0 6.37 0 9.556 1.24 11.99 1.09 2.14 2.83 3.88 4.97 4.97C24.645 89 27.83 89 34.2 89h31.85c6.37 0 9.556 0 11.99-1.24 2.14-1.09 3.88-2.83 4.97-4.97 1.24-2.434 1.24-5.62 1.24-11.99V33.75H68a6.5 6.5 0 01-6.5-6.5V11z",
    fill: "#FF9E00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 13,
    rx: 1.625,
    transform: "matrix(-1 0 0 1 53.375 41.875)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 6.5,
    rx: 1.625,
    transform: "matrix(-1 0 0 1 53.375 58.125)",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNjEuNSAxMUgzNC4yQzI3LjgyOTQgMTEgMjQuNjQ0MSAxMSAyMi4yMTA5IDEyLjIzOThDMjAuMDcwNSAxMy4zMzA0IDE4LjMzMDQgMTUuMDcwNSAxNy4yMzk4IDE3LjIxMDlDMTYgMTkuNjQ0MSAxNiAyMi44Mjk0IDE2IDI5LjJWNzAuOEMxNiA3Ny4xNzA2IDE2IDgwLjM1NTkgMTcuMjM5OCA4Mi43ODkxQzE4LjMzMDQgODQuOTI5NSAyMC4wNzA1IDg2LjY2OTYgMjIuMjEwOSA4Ny43NjAyQzI0LjY0NDEgODkgMjcuODI5NCA4OSAzNC4yIDg5SDY2LjA1QzcyLjQyMDYgODkgNzUuNjA1OSA4OSA3OC4wMzkxIDg3Ljc2MDJDODAuMTc5NSA4Ni42Njk2IDgxLjkxOTYgODQuOTI5NSA4My4wMTAyIDgyLjc4OTFDODQuMjUgODAuMzU1OSA4NC4yNSA3Ny4xNzA2IDg0LjI1IDcwLjhWMzMuNzVINjhDNjQuNDEwMSAzMy43NSA2MS41IDMwLjgzOTkgNjEuNSAyNy4yNVYxMVoiIGZpbGw9IiNGRjlFMDAiLz4KPHJlY3Qgd2lkdGg9IjYuNSIgaGVpZ2h0PSIxMyIgcng9IjEuNjI1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA1My4zNzUgNDEuODc1KSIgZmlsbD0id2hpdGUiLz4KPHJlY3Qgd2lkdGg9IjYuNSIgaGVpZ2h0PSI2LjUiIHJ4PSIxLjYyNSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNTMuMzc1IDU4LjEyNSkiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgSuspicious as ReactComponent };